import InlineSVG from "react-inlinesvg";
import { PromoCardContainer } from "./styles.js";

interface PromoCardProps {
  badge: string;
  title: string;
  description: string;
  ctaLabel: string;
  ctaUrl: string;
  onClose: () => void;
}

export default function PromoCard({ badge, title, description, ctaLabel, ctaUrl, onClose }: PromoCardProps) {
  const handleCtaClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.open(ctaUrl, "_blank");
  };

  return (
    <PromoCardContainer>
      <InlineSVG
        src="/assets/close.svg"
        className="close"
        onClick={(event: React.MouseEvent) => {
          event.stopPropagation();
          onClose();
        }}
      />
      <div className="resources-title">
        <div className="resources-title-new"> {badge}</div>
        <div className="resources-title-text">{title}</div>
        <div className="resources-description">{description}</div>
      </div>
      <div className="resources-container">
        <a
          className="resource"
          target="_blank"
          href="#"
          onClick={handleCtaClick}
        >
          {ctaLabel}
        </a>
      </div>
    </PromoCardContainer>
  );
}
